function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "icons/discard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.151,5.16733871 L12.619,15.3336694 C12.599,15.7076613 12.293,16 11.922,16 L3.079,16 C2.708,16 2.402,15.7076613 2.382,15.3336694 L1.85,5.16733871 C1.83,4.77923387 2.125,4.44858871 2.51,4.42741935 C2.896,4.40927419 3.223,4.70564516 3.243,5.09274194 L3.741,14.59375 L11.26,14.59375 L11.758,5.09274194 C11.778,4.70564516 12.109,4.41028226 12.491,4.42741935 C12.876,4.44858871 13.171,4.77923387 13.151,5.16733871 Z M15,2.81350806 C15,3.2016129 14.688,3.5171371 14.303,3.5171371 L0.698,3.5171371 C0.313,3.5171371 0,3.2016129 0,2.81350806 C0,2.42540323 0.313,2.10987903 0.698,2.10987903 L4.535,2.10987903 L4.535,0.527217742 C4.535,0.1875 4.76,0 5.097,0 L9.903,0 C10.241,0 10.466,0.1875 10.466,0.527217742 L10.466,2.10987903 L14.303,2.10987903 C14.688,2.10987903 15,2.42540323 15,2.81350806 Z M5.756,2.10987903 L9.244,2.10987903 L9.244,1.23084677 L5.756,1.23084677 L5.756,2.10987903 Z M6.049,13.5383065 L6.063,13.5383065 C6.401,13.5383065 6.667,13.2116935 6.659,12.8719758 L6.482,5.27016129 C6.474,4.93044355 6.198,4.65322581 5.857,4.66028226 C5.52,4.66834677 5.253,4.94556452 5.261,5.28528226 L5.439,12.9032258 C5.447,13.2379032 5.718,13.5383065 6.049,13.5383065 Z M8.925,13.5383065 C9.256,13.5383065 9.528,13.2560484 9.536,12.921371 L9.713,5.3296371 C9.721,4.98991935 9.454,4.70362903 9.117,4.69556452 C8.775,4.69052419 8.5,4.9546371 8.492,5.29435484 L8.315,12.8931452 C8.307,13.2328629 8.574,13.5383065 8.911,13.5383065 L8.925,13.5383065 Z",
  id: "Trashcan",
  fill: "#5C7284"
}));

function SvgIconDiscard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "13px",
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/discard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiscard);
export default __webpack_public_path__ + "static/media/icon_discard.7310e6ec.svg";
export { ForwardRef as ReactComponent };